import * as React from 'react';
import { styled } from '@glitz/react';
import { Position, Flyout as FlyoutBase } from '@avensia/excite-ui';
import MobileMenu from 'webapp/shell/main-menu/MobileMenu';
import { ProgressiveHydration, useStaticData } from '@avensia/excite';
import { createMinLargeViewportDecorator } from 'webapp/viewport';
import { ZIndex } from 'webapp/z-index';
import { useFlyout } from 'webapp/shell/flyout-context';
import { useAuthModal } from 'webapp/authentication/use-auth-modal';

export function MainMenu() {
  useAuthModal();
  const menu = useStaticData<NordicNest.Api.CfMenuApiModel>();
  const { isOpen, close } = useFlyout('Menu');
  return (
    <ProgressiveHydration skipHydration renderOnUpdate={isOpen}>
      <Flyout zIndex={ZIndex.Overlay} keepChildrenMounted visible={isOpen} position={Position.Right} onClose={close}>
        {menu && <MobileMenu isOpen={isOpen} menu={menu} close={close} />}
      </Flyout>
    </ProgressiveHydration>
  );
}

const Flyout = styled(FlyoutBase, createMinLargeViewportDecorator({ width: 'auto', display: 'none' }), {
  overflow: 'hidden',
  backgroundColor: t => t.mobileMenu?.backgroundColor,
});
